<div [attr.data-comp]="'Categories'" [attr.data-filters]="appliedFilters" class="content content-md" >
  <div [ngClass]="scrollContentClass">
    @if (isBusy || searchService.isSearching || allAssetsLabel === 'main.data.all_assets') {
      <app-overlay
      imgClass='cg-overlay-img'></app-overlay>
    }
    @if (!searchService.isSearching && !searchResults && allAssetsLabel !== 'main.data.all_products') {
      <div>
        @for (category of rouseCategories; track category) {
          <div id="content-list" class="list list-md">
            <app-categories-item
              [item]="category"
              [onClick]="onItemClick"
              [allAssetsLabel]="allAssetsLabel"
              [selectedCustomerCount]="getSelectedCustomerCount()"
            ></app-categories-item>
          </div>
        }
      </div>
    }
  </div>
  @if (searchResults) {
    <app-search-results />
  }
</div>
